module.exports = "/static/images/BCT-logo-vertical.svg";